import { useEffect, useState } from 'react';
import { useAuth, canUseApp, isSimpleMenu } from '@/auth/AuthContext';
import { HubTabs } from '@/components/HubTabs';
import EngRentals from '@/pages/engineering/EngRentals';
import BihinLoans from '@/pages/bihin/BihinLoans';
import { engApi } from '@/pages/engineering/engApi';

/** 貸出（技術資産 / 備品）— ひとつの画面。 */
export default function RentalsHub({ side = 'eng' }) {
  const { user } = useAuth();
  const simple = isSimpleMenu(user);
  const [access, setAccess] = useState(null);

  useEffect(() => {
    if (side === 'eng') return;
    engApi.access().then(setAccess).catch(() => {});
  }, [side]);

  const tabs = [
    {
      key: 'eng', label: '技術の貸出', node: <EngRentals access={access || undefined} />,
      visible: side === 'eng' || (simple && canUseApp(user, 'engineering')),
    },
    {
      key: 'bihin', label: '備品の貸出', node: <BihinLoans />,
      visible: side === 'bihin' || (simple && canUseApp(user, 'bihin')),
    },
  ];

  return <HubTabs tabs={tabs} initial={side} testid="rentals-hub" />;
}
